import React from 'react';

type FontAwesomeIconProps = {
  icon: string;
  className?: string;
} & React.ComponentProps<'i'>;

export const FontAwesomeIcon: React.FC<FontAwesomeIconProps> = ({ icon, className = '', ...rest }) => {
  return <i className={`${icon} ${className}`} {...rest} />;
};
